import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Wema";

const WemaGardens = () => {
  const projectId = 49;
  const title = "WEMA GARDENS - LAIKIPIA COUNTY";

  const mapConfig = {
    minZoom: 5,
    zoom: 6,
    bounds: [
      [5.08, -124.11],
      [-24, -69],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/wema-gardens-naro-moru/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSf1YNr5mo0cxrPMGyvJTHxtsv7gVZpIrH_JF1kxflHGEEt_Uw/viewform"
    />
  );
};

export default WemaGardens;
